import graphql from "babel-plugin-relay/macro";

export default graphql`
  query getLeadFieldsQuery($propertyId: ID!) {
    leadFields(propertyId: $propertyId) {
        fieldId
        fieldOptions{
          default
          display
          id
          position
        }
        fieldTag
        id
        label
        type
    }
  }
`;
